import httpClient from "@/services/base.service.js";

export default {
  getRecaptchaKey: function () {
    return httpClient.get("/api/v1/clientsetting/recaptchakey");
  }
};
